// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LoadingUserDetailsAction, UserDetailsActionTypes, CompleteLoadUserDetailsAction,
    FailLoadUserDetailsAction } from './user-details.actions';
import { UserService } from '@app/core';

@Injectable()
export class UserDetailsEffects {
  @Effect()
  requestOnLoadUsers$ = this.actions$.pipe(
    ofType<LoadingUserDetailsAction>(UserDetailsActionTypes.USER_DETAILS_LOADING),
    switchMap(action => this.requestUser(action.payload))
  );

  constructor(private actions$: Actions, private usersService: UserService) {}

  private requestUser(username: string): Observable<CompleteLoadUserDetailsAction | FailLoadUserDetailsAction> {
    return this.usersService.get(username).pipe(
        map((response: any) => new CompleteLoadUserDetailsAction(response)),
        catchError((error) => of(new FailLoadUserDetailsAction(username)))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/user-details/user-details.effects.ts